import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@core/http-legacy';

import {
  OfferTranslations,
  OfferTranslationsResponse,
  OfferTranslationsUpdateRequest,
} from './offer-translations.types';

@Injectable({
  providedIn: 'root',
})
export class OfferTranslationsHttpService {
  public httpApi = inject(HttpApiService);

  public fetchOne$(offerId: number, targetLangCode: string): Observable<OfferTranslations> {
    return this.httpApi
      .get(`/offers/${offerId}/translate`, { target_lang_code: targetLangCode })
      .pipe(map((response: OfferTranslationsResponse) => response.offer));
  }

  public updateTranslations$(
    offerId: number,
    payload: OfferTranslationsUpdateRequest,
  ): Observable<OfferTranslations> {
    return this.httpApi
      .patch(`/offers/${offerId}/translate`, null, { ...payload })
      .pipe(map((response: OfferTranslationsResponse) => response.offer));
  }
}
